import produce from "immer"
import { ASC } from "const"
import { MarkovStartvectorState } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovStartvectorState: MarkovStartvectorState = {
    startvectorId: null,
    stateId: null,
    expression: "",
}

const initMarkovStartvectorStateState: types.MarkovStartvectorStateState = {
    stateList: {},
    stateIds: [],
    stateEdit: initMarkovStartvectorState,

    calculatedExpressions: {},

    sortColumn: "order",
    sortOrder: ASC,
    filters: {},

    reloadList: true,
    reloadEdit: true,
}

const markovStartvectorStateReducer = produce((
    draft: types.MarkovStartvectorStateState = initMarkovStartvectorStateState,
    action: ActionTypes = null,
): types.MarkovStartvectorStateState => {
    switch (action.type) {
        case types.MARKOV_STARTVECTOR_STATE_LIST:
            draft.stateList = action.stateList
            return draft

        case types.MARKOV_STARTVECTOR_STATE_IDS:
            draft.stateIds = action.stateIds
            return draft

        case types.MARKOV_STARTVECTOR_STATE_EDIT:
            draft.stateEdit = action.state
            return draft

        case types.MARKOV_STARTVECTOR_STATE_CALCULATED_EXPRESSIONS:
            draft.calculatedExpressions = action.calcualted
            return draft

        case types.MARKOV_STARTVECTOR_STATE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_STARTVECTOR_STATE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.MARKOV_STARTVECTOR_STATE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_STARTVECTOR_STATE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovStartvectorStateReducer
